export default __webpack_public_path__ + "static/media/opensans-regular-webfont.15fe26a2.woff2";